module.exports = __webpack_public_path__ + "static/media/NoSmoking – 1.7ff8da52.jpg";